import { JSX } from 'react';
import { HeroBannerCarousel } from '@ahc-digital/component-library';
import { Placeholder, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { HERO_BANNER_CAROUSEL_CONTAINER } from 'src/shared/static';
import { GetHeroBannerCarouselModel } from './B02HeroBannerCarousel.service';
import { B02HeroBannerCarouselProps } from './B02HeroBannerCarousel.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: B02HeroBannerCarouselProps): JSX.Element => {
  const id = props?.params?.AnchorLinkTargetName;
  const phKey = HERO_BANNER_CAROUSEL_CONTAINER + `-${props?.params?.DynamicPlaceholderId}`;
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <>
      {isEditing ? (
        <div className="component-content">
          <strong>
            <i>
              **Note: Carousel rendering parameter updates will be visible on the rendered page**
            </i>
          </strong>
          {props?.rendering && <Placeholder name={phKey} rendering={props?.rendering} />}
        </div>
      ) : (
        <>
          <HeroBannerCarousel
            id={id}
            className={translationClasses(props?.params)}
            data-component={marketingRenderingName}
            {...GetHeroBannerCarouselModel(props)}
          />
        </>
      )}
    </>
  );
};
